import React, { Component } from 'react';
import { Stage, Layer, Circle, Label, Text, Tag } from 'react-konva';
import { colors } from '../../../constants';
import _ from 'lodash';
import { Transformer } from 'react-konva';
import './CanvasContent.css';

class CanvasContent extends Component {

    state = {
        color: colors
    };

    render() {
        let labels = _.map(this.props.circleData, (rect, i) => {
            if (this.props.groupId === rect.groupId) {

                let prices = [];
                this.props.circleData.map(data => {
                    if (this.props.groupId === data.groupId) {
                        prices.push(data.price)
                    }
                })

                let x = (100 * (+rect.value - 100)) / 900 + 5;
                let posX = x * 332 / 100
                let sum = _.sum(prices)
                let avg = sum/prices.length
                let y = 1-((+rect.price - 1) /(avg*2))
                let posY = y * 332

                return (
                    <Label
                        key={i}
                        // ref={rect.subName ? ref=>this[`${rect.name}`]=ref : ref=>this[`${rect.name}`]=ref}
                        x={posX + 55}
                        y={posY+15}
                    >
                        <Tag

                            fill='white'
                            pointerDirection='down'
                            lineJoin='round'
                            shadowColor='#ddd'
                            cornerRadius= {5}
                        />
                        <Text
                            text={rect.name}
                            fontFamily='Calibri'
                            fontStyle= "bold"
                            fontSize={10}
                            padding={5}
                            fill='black'
                        />
                    </Label>
                )
            }
        });
        let rounds = _.map(this.props.circleData, (rect, i) => {
            if (this.props.groupId === rect.groupId) {

                let prices = [];
                this.props.circleData.map(data => {
                    if (this.props.groupId === data.groupId) {
                        prices.push(data.price)
                    }
                })

                let fill = this.state.color.find(r => r.key === rect.key) ? this.state.color.find(r => r.key === rect.key).color : this.state.color[0].color;
                let x = (100 * (+rect.value - 100)) / 900 + 5;
                let posX = x * 332 / 100
                let sum = _.sum(prices)
                let avg = sum/prices.length
                let y = 1-((+rect.price - 1) /(avg*2))
                let posY = y * 332

                return (
                    <Circle
                        key={i}
                        // ref={rect.subName ? ref=>this[`${rect.name}`]=ref : ref=>this[`${rect.name}`]=ref}
                        x={posX}
                        y={posY}
                        scaleX='1'
                        scaleY='1'
                        width={'20'}
                        height={'20'}
                        stroke="black"
                        strokeWidth='2'
                        fill={'#' + fill}
                        type='circle'
                        context='text'
                        name={rect.name}
                        zIndex={5}
                    />
                )
            }
        });

        return (
            <div className="canvas-content">
                <div className='text-part'>
                    <p className='title'>Price</p>
                    <div className='label-val'>
                        <p className='high'>Above Par</p>
                        <p className='medium'>At Par</p>
                        <p className='low'>Below Par</p>
                    </div>
                </div>
                <div className='stage-box'>
                    <Stage
                        width={332}
                        height={332}
                        ref={ref => this.stage = ref}
                    >
                        <Layer
                            ref={ref => this.layer = ref}
                            fillPatternImage={this.state.fillPatternImage}
                        >
                            {rounds}
                            {labels}
                            <Transformer
                                ref={node => {
                                    this.transformer = node;
                                }}
                            />
                        </Layer>
                    </Stage>
                </div>
                <div className='bottom-text-part'>
                    <div className='label-val'>
                        <p className='low'>Low - 100</p>
                        <p className='medium'></p>
                        <p className='high'>High - 1000</p>
                    </div>
                    <p className='title'>Ability to Compete</p>
                </div>
                <div id="fair_value"></div>
                <table className="bg-table">
                    <tbody>
                        <tr>
                            <td className='topLeft colorBox'  style={{ background: "#bfd5d2" }}></td>
                            {/* <td className='topMiddle'></td> */}
                            <td className='topRight' style={{ background: "#ddd" }}></td>
                        </tr>
                        {/* <tr>
                            <td className='middleLeft'></td>
                            <td className='middleMiddle colorBox'></td>
                            <td className='middleRight'></td>
                        </tr> */}
                        <tr>
                            <td className='btmLeft' style={{ background: "#ddd" }}></td>
                            {/* <td className='btmMiddle'></td> */}
                            <td className='btmRight colorBox' style={{ background: "#bfd5d2" }}></td>
                        </tr>
                    </tbody>
                </table>
            </div>

        );
    }
}
export default (CanvasContent);



// WEBPACK FOOTER //
// ./src/components/PricingValueComponent/Results/Tabs/CanvasContent/CanvasContent.jsx